@import "../../variables.scss";

.horizontalline {
  &__line {
    border-top: 1px $color-light-grey solid;
  }
  &__first {
    width: 2rem;
  }
  &__last {
    width: 100%;
  }
  &__text {
    color: $color-grey;
    font-size: 12px;
    margin: 0rem 0.2rem;
    white-space: nowrap;
  }
  &__subtext {
    margin-top: 0.5rem;
    font-size: 13px;
    color: $color-grey;
  }
}
